import * as React from 'react';

import { SpacingUnit } from './config';

export type SpacingContextValue = {
  hSpacing?: SpacingUnit;
  vSpacing?: SpacingUnit;
  betweenRows?: SpacingUnit;
};

export const SpacingCtx = React.createContext({});

export const useSpacingCtx = (): SpacingContextValue =>
  React.useContext(SpacingCtx);

export const usePassThroughSpacing = (
  propsSpacing: SpacingContextValue
): SpacingContextValue => {
  const ctx = useSpacingCtx();

  const hSpacing = propsSpacing.hSpacing || ctx.hSpacing;

  const vSpacing = propsSpacing.vSpacing || ctx.vSpacing;

  const betweenRows = propsSpacing.betweenRows || ctx.betweenRows;

  return React.useMemo<SpacingContextValue>(
    () => ({
      hSpacing,
      vSpacing,
      betweenRows,
    }),
    [hSpacing, vSpacing, betweenRows]
  );
};
